import { render, staticRenderFns } from "./AuthenticityQuestions.vue?vue&type=template&id=5e2beda7&scoped=true"
import script from "./AuthenticityQuestions.vue?vue&type=script&lang=js"
export * from "./AuthenticityQuestions.vue?vue&type=script&lang=js"
import style0 from "./AuthenticityQuestions.vue?vue&type=style&index=0&id=5e2beda7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2beda7",
  null
  
)

export default component.exports